import { render, staticRenderFns } from "./WelcomeSubscribeAndSave.vue?vue&type=template&id=387c28b6&scoped=true&lang=pug&"
import script from "./WelcomeSubscribeAndSave.vue?vue&type=script&lang=js&"
export * from "./WelcomeSubscribeAndSave.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeSubscribeAndSave.vue?vue&type=style&index=0&id=387c28b6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c28b6",
  null
  
)

export default component.exports